import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Route, withRouter, Redirect, Switch } from "react-router-dom";
import { connect } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import Popover from "@material-ui/core/Popover";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { withLastLocation } from "react-router-last-location";
import { withStyles, withTheme } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import PeopleIcon from "@material-ui/icons/People";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MicIcon from "@material-ui/icons/Mic";
import MicOffIcon from "@material-ui/icons/MicOff";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Trans, withTranslation } from "react-i18next";
import PortalDrawer from "./components/menu/PortalDrawer";
import UserLayouts from "./UserLayouts";
import classNames from "classnames";
import PortalTabs from "./components/PortalTabs";
import ElementWrapper from "./components/ElementWrapper";
import SearchSecondaryInfo from "./components/search/SearchSecondaryInfo";
import SearchPage from "./components/search/SearchPage";
import UserSettings from "./administration/user-profile/UserSettings";
import { Badge, FormControl, Hidden, InputLabel } from "@material-ui/core";
import NotificationDialog from "./components/messages/NotificationDialog";
import CreateContentFlow from "./components/content/CreateContentFlow";
import CustomFields from "./components/customfields/CustomFields";
import { setLayoutType, changeSelected } from "./redux/actions/layoutActions";
import LanguageIcon from "@material-ui/icons/Language";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { changeLanguage } from "./redux/actions/universalActions";
import CreateKnowledgeSource from "./administration/knowledgesource/CreateKnowledgeSource";
import ManageKnowledgeSources from "./administration/knowledgesource/ManageKnowledgeSources";
import TranslationEditor from "./administration/TranslationEditor";
import ReusableSections from "./components/content/reusable-section/ReusableSections";
import UserAdministration from "./administration/UserAdministration";
import ManageAttachments from "./administration/ManageAttachments";
import ManageRequiredReading from "./administration/ManageRequiredReading";
import TaxonomyMaintenance from "./administration/TaxonomyMaintenance";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import DocumentViewer from "./components/DocumentViewer";
import Select from "@material-ui/core/Select";
import axios, { taxServiceClient } from "./AxiosClient";
import JobManager from "./administration/JobManager";
import ExpertQuestionMaintenance from "./components/expert-questions/ExpertQuestionMaintenance";
import FullscreenDiscussion from "./components/discussions/FullscreenDiscussion";
import KnowledgeItemView from "./components/content/knowledge-item/KnowledgeItemView";
import {
  currentUserHasRole,
  Role,
  currentUserIsOperator,
} from "./utils/RoleUtils";
import SystemConfiguration from "./administration/configuration/SystemConfiguration";
import InfoIcon from "@material-ui/icons/Info";
import LinkOffIcon from "@material-ui/icons/LinkOff";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import LinkIcon from "@material-ui/icons/Link";
import { mdiLightbulbOnOutline } from "@mdi/js";
import TaxonomyDiscussions from "./components/taxonomy/discussions/TaxonomyDiscussions";
import DocumentManager from "./administration/DocumentManager";
import PropertyNames from "./PropertyNames";
import ManageBatchReindexing from "./administration/knowledgesource/ManageBatchReindexing";
import Dictaphone from "./components/voice-to-text/Dictaphone";
import TemplatePicker from "./components/content/TemplatePicker";

import { Table, TableRow, TableCell } from "@material-ui/core";
import Media from "react-media";
import TopicHomePage from "./components/topic/TopicHomePage"
import DisplayLocation from "./components/taxonomy/discussions/DisplayLocation";

const languages = [
  { key: "en_GB", text: "global_language_english" },
  { key: "de_DE", text: "global_language_german" },
  { key: "fr_CA", text: "global_language_french" },
  { key: "es_ES", text: "global_language_spanish" },
  { key: "pt_BR", text: "global_language_portugese" },
  { key: "nb_NO", text: "global_language_norwegian" },
];

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
    marginRight: "5px",
  },
  searchIcon: {
    width: theme.spacing(9),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  exitButton: {
    marginLeft: "auto",
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 350,
      },
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(6),
    },
  },
  layoutButton: {
    marginRight: -10,
  },
  layoutMenu: {
    marginTop: 20,
  },
  tabsContainer: {
    display: "flex",
    marginLeft: 12,
    marginRight: 24,
    minHeight: 48,
  },
  "fade-enter": {
    opacity: 0,
    zIndex: 1,
  },
  "fade-enter-active": {
    opacity: 1,
    transition: "opacity 250ms ease-in",
  },
  appBar: {
    marginBottom: 10,
  },
  searchStringText: {
    color: theme.palette.common.white,
    // marginTop: 5,
    // marginLeft: 15,
    padding: 12,
  },
  modalAppBar: {
    position: "relative",
  },
  modalToolbar: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  docViewer: {
    display: "flex",
  },
  dialogContainer: {
    display: "flex",
    flexDirection: "column",
    // overflowY: "hidden",
    // overflowX: "hidden",
  },
  green: {
    color: theme.palette.success.main,
  },
  red: {
    color: theme.palette.error.main,
  },
  popper: {
    zIndex: 9999999,
    boxShadow:
      "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)",
    marginTop: 7,
    maxWidth: "50%",
    maxHeight: "75%",
    overflowX: "hidden",
    overflowY: "auto",
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${
          theme.palette.background.paper
        } transparent`,
      },
    },
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  paper: {
    // maxWidth: "50%",
  },
  emptyText: {
    textAlign: "center",
    marginBottom: 15,
  },
  tooltip: {
    zIndex: 9999999999999999999,
  },
  infoButton: {
    color: theme.palette.common.white,
  },
  teamSelect: {
    "&:before": {
      borderColor: "white",
    },
    "&:after": {
      borderColor: "white",
    },
  },
  icon: {
    color: "white",
  },
  select: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  menuCellLeft: {
    border: "none",
    padding: theme.spacing(0.75),
  },
  menuCellRight: {
    border: "none",
    padding: theme.spacing(0.75),
    paddingRight: theme.spacing(2),
  },
  menuTable: {
    padding: theme.spacing(2),
  },
});
let messageRef = React.createRef();
let whyPopperRef = React.createRef();
export class KpsLayout extends Component {
  constructor(props) {
    super(props);
    this.layoutMenuRef = React.createRef();
    this.state = {
      entryAnimation: "",
      exitAnimation: "",
      main: true,
      userTabs: true,
      route: {},
      tailData: {},
      documentData: {},
      layoutData: {},
      edit: false,
      searchOpened: false,
      drawerOpen: false,
      layoutMenuAnchor: null,
      selected: "main",
      fullScreenPortlet: {},
      searchAnchorEl: null,
      messageAnchorEl: null,
      searchString: this.props.match.params.str || "",
      fullscreenDialogOpen: true,
      messageOpened: false,
      handleMessageClickAway: false,
      routeSearchString: this.props.match.params.str || "",
      languageMenu: null,
      userTeams: [],
      selectedTeam: "",
      resolutions: [],
      whyPopperOpen: false,
      whyPopperAnchorEl: null,
      numSearchResults: 0,
      micOn: this.props.currentUser.userSettings && this.props.currentUser.userSettings.micAlwaysEnabled ? this.props.currentUser.userSettings.micAlwaysEnabled : false,
      // micTempOn:false,
      searchTime: 0,
      secondaryInfo: this.props.applicationProperties[
        PropertyNames.SEARCH_SECONDARY_INFO
      ]
        ? JSON.parse(
            this.props.applicationProperties[
              PropertyNames.SEARCH_SECONDARY_INFO
            ]
          )
        : ["global_topic"],
      topicName: "",
      topicId: -1,
      showTopicDialog: false,
    };
  }
  topicCheck = (topic) => {
    let result = this.props.taxonomyNodeLookup.filter(t => {
      let matches =         
        (t.name && t.name.toLowerCase() === topic.toLowerCase() && t.type === "topic")  
          ? true
          : false 
      return matches

    }).map(t => {
      return { id: t.id, name: t.name, type: t.type, taxArray:[]}
    })
    return result
  }

  loadLayoutFromPath = (layoutId) => {
    //we have been passed an id and we need to figure out what it is
    let url = Number.isInteger(parseInt(layoutId)) ? `/portalLayout/${layoutId}` : `/portalLayout/byTitle/${layoutId}`
    axios.get(url, { withCredentials: true }).then((res) => {
      if (Array.isArray(res.data)) {
        if (res.data.length > 0) {
          let selectedTeam = res.data[0].teamPortals.length > 0 ? res.data[0].teamPortals[0].teamId : null
          if (selectedTeam !== null && this.state.userTabs === true) {
            this.setState({ userTabs: false, selectedTeam: selectedTeam })
          }
          this.props.history.replace(`/layout/${res.data[0].id}`)
        }
      } else {
        let selectedTeam = res.data.teamPortals.length > 0 ? res.data.teamPortals[0].teamId : null
        if (selectedTeam !== null && this.state.userTabs === true) {
          this.setState({ userTabs: false, selectedTeam: selectedTeam })
        }
        this.props.changeSelected(res.data.id)
        this.props.history.replace("/");
      }
    })
  }
  routeChecks = () => {
    //Content Guru supplied request params
    const params = new URLSearchParams(this.props.location.search);
    let documentid = params.get("KMS_Article") //Pass article ID to display that exact one
    let decisiontree = params.get("KMS_DecisionTree") //Pass decision tree ID to display that exact one
    let topic = params.get("KMS_Topic") //to pass through to a collection to all articles in that collection
    let search = params.get("KMS_Query") //General Search
    let page = params.get("KMS_Page") // A particular page to pass your query through to
    let layout = params.get("KMS_Layout") // Select a specific layout

    if (layout !== null) {
      this.loadLayoutFromPath(layout)
      // this.props.history.replace(`/layout/${layout}`)
    }
    if (topic !== null) {
      //check whether we can map the value against the user's taxonomy
      let result = this.topicCheck(topic)
      if (result.length > 0) {
        this.setState({topicName: result[0].name, topicId: result[0].id},() => this.props.history.replace(`/topic/${result[0].id}`))
      } else {
        //we haven't been able to establish the topic needed let the component prompt for it
        this.props.history.replace(`/topic`)
      }
    }
    let topicMatch = this.props.location.pathname.match(/\/topic[/]?(.*)$/);
    if (topicMatch) {
      let topic = this.props.taxonomyNodeLookup.filter(t => t.id === topicMatch[1] && t.type === "topic")
      if (topic.length > 0) {
        this.setState({topicName: topic[0].name, topicId: topic[0].id})
      }
    }
    if (documentid && documentid !== null) {
      this.props.history.replace(`/full/document/${documentid}`);
      if (search && search !== null) {
        this.setState({initialSearch: search})
      }
    } else {
      if (search !== null) {
        this.props.history.replace(`/search/${search}`);
      }
    }
    if (
      this.props.location.pathname === "/fullscreen" &&
      Object.entries(this.state.fullScreenPortlet).length === 0
    ) {
      this.props.history.replace("/");
    }
    let match = this.props.location.pathname.match(/\/search[/]?(.*)$/);
    if (match && (match.length < 2 || !match[1])) {
      // this.props.history.replace("/");
      this.setState({
        routeSearchString: "",
        searchString: "",
        secondaryInfo: this.props.applicationProperties[
          PropertyNames.SEARCH_SECONDARY_INFO
        ]
          ? JSON.parse(
              this.props.applicationProperties[
                PropertyNames.SEARCH_SECONDARY_INFO
              ]
            )
          : ["global_topic"],
      });
      // without the setTimeout it focuses but you get
      // no cursor. without the blur it focuses but you get no cursor.
      // with a lower timeout, it focuses but you get no cursor.
      // probably a huge fudge that won't work some of the time..
      // praise to the javascript gods
      setTimeout(() => {
        this.state.searchAnchorEl && this.state.searchAnchorEl.blur();
        this.state.searchAnchorEl && this.state.searchAnchorEl.focus();
      }, 250);
    } else if (match && match.length > 1) {
      if (this.state.searchString !== match[1]) {
        this.setState({ resolutions: [] });
      }
      let searchString = match[1].split("/document/");
      this.setState({
        routeSearchString: searchString[0],
        searchString: searchString[0],
        secondaryInfo: this.props.applicationProperties[
          PropertyNames.SEARCH_SECONDARY_INFO
        ]
          ? JSON.parse(
              this.props.applicationProperties[
                PropertyNames.SEARCH_SECONDARY_INFO
              ]
            )
          : ["global_topic"],
      });
    }
    let layoutMatch = this.props.location.pathname.match(/\/layout[/]?(.*)$/);
    if (layoutMatch) {
      this.loadLayoutFromPath(layoutMatch[1])
    }
    if (
      this.props.location.pathname === "/" ||
      this.props.location.pathname.startsWith("/layout")
    ) {
      this.setState({ main: true, searchString: "", resolutions: [] });
    } else {
      this.setState({ main: false });
    }
  };

  componentDidMount() {
    this.routeChecks();
    this.setState({
      messageAnchorEl: ReactDOM.findDOMNode(messageRef.current),
    });
    let sharedLayoutsPresent = false;
    axios
      .get(`/portalLayout/${this.props.currentUser.userId}/team/withlayouts`, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.length > 0) {
          sharedLayoutsPresent = true;
          let everyone = res.data.filter(
            (team) => team.isDefault === true
          );
          let currentSelection = res.data.filter(
            (team) => team.teamId === this.state.selectedTeam
          );
          if (currentSelection.length === 0) {
            if (everyone.length > 0) {
              this.setState({ selectedTeam: everyone[0].teamId, userTeams: res.data });
            } else {
              this.setState({ selectedTeam: res.data[0].teamId, userTeams: res.data });
            }
          } else {
            this.setState({ userTeams: res.data });
          }
          let userHasTeamLayoutAndNoUserLayouts = false;
          axios
            .get("/portalLayout/?team=false", { withCredentials: true })
            .then((res) => {
              if (
                res.data.length <= 1 &&
                res.data[0].gridLayout === '{"lg":[]}'
              ) {
                userHasTeamLayoutAndNoUserLayouts = true;
              }
              if (
                this.props.currentUser.userType === "limited" ||
                userHasTeamLayoutAndNoUserLayouts
              ) {
                this.toggleTeamLayouts();
              }
            });
        }
      });
    // this.setState({micOn:this.props.currentUser.userSettings.micAlwaysEnabled});
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location !== prevProps.location) {
      this.routeChecks();
    }
    if (
      this.props.teamLayoutsLastUpdate &&
      this.props.teamLayoutsLastUpdate != prevProps.teamLayoutsLastUpdate
    ) {
      this.getUserTeams();
    }
  }

  openSearchFilter = () => {
    this.setState({ searchOpened: true }, () => {
      if (!this.props.location.pathname.includes("search")) {
        this.props.history.push("/search/");
      }
    });
  };

  handleInputRef = (node) => {
    this.setState({ searchAnchorEl: node });
  };

  handleMessageInputRef = (node) => {
    this.setState({ messageAnchorEl: node });
  };

  handleClickAway = () => {
    this.setState({ searchOpened: false });
  };

  handleMessageClickAway = () => {
    this.setState({ handleMessageClickAway: false });
  };
  getUserTeams = () => {
    axios
      .get(`/portalLayout/${this.props.currentUser.userId}/team/withlayouts`, {
        withCredentials: true,
      })
      .then((res) => {
        this.setState({ userTeams: res.data });
      });
  };
  teamChange = (evt) => {
    this.setState({ selectedTeam: evt.target.value }, () => this.props.changeSelected(0));
  };
  closePopper = () => {
    this.setState({ whyPopperOpen: false });
  };
  showWhyLinkPopper = (e) => {
    this.setState({ whyPopperAnchorEl: e.target, whyPopperOpen: true });
  };
  activateSearch = () => {
    this.state.searchString
      ? this.props.history.push(`/search/${this.state.searchString}`)
      : this.props.history.push(`/search/`);
  };
  render() {
    const { classes, theme, t } = this.props;
    return (
      <div
        style={{
          // height: "100%",
          display: "flex",
          flexDirection: "column",
          // overflow: "auto",
        }}
      >
        <Dictaphone
          micOn={this.state.micOn}
          handleSearch={(string) =>
            this.setState({ searchString: string }, this.activateSearch)
          }
        />
        <PortalDrawer
          open={this.state.drawerOpen}
          onClose={this.toggleDrawer}
        />
        <AppBar
          position="sticky"
          className={classes.appBar}
          aria-label={t("app_header")}
        >
          <Toolbar>
            {this.state.main ? (
              <IconButton
                className={classes.menuButton}
                color="inherit"
                aria-label={t("open_drawer")}
                id="open-drawer"
                onClick={this.toggleDrawer}
              >
                <MenuIcon />
              </IconButton>
            ) : (
              <IconButton
                className={classes.menuButton}
                color="inherit"
                aria-label={t("report_breadcrumb_home")}
                onClick={this.goHome}
                id="go-home"
              >
                <ArrowBackIcon />
              </IconButton>
            )}
            <Typography
              className={classes.title}
              variant="h6"
              component="h1"
              color="inherit"
              noWrap
              id="title"
              onClick={this.goHome}
            >
              <Trans i18nKey="app_title" />
            </Typography>
            <div className={classes.grow} />
            <Tooltip
              title={<Typography>{"Change language"}</Typography>}
              enterDelay={300}
            >
              <IconButton
                color="inherit"
                aria-label="Change language"
                aria-owns={
                  this.state.languageMenu ? "language-menu" : undefined
                }
                aria-haspopup="true"
                onClick={this.handleLanguageIconClick}
                data-ga-event-category="AppBar"
                data-ga-event-action="language"
              >
                <LanguageIcon />
              </IconButton>
            </Tooltip>
            <Menu
              id="language-menu"
              anchorEl={this.state.languageMenu}
              open={Boolean(this.state.languageMenu)}
              onClose={this.handleLanguageMenuClose}
            >
              {languages.map((language) => (
                <MenuItem
                  component="a"
                  data-no-link="true"
                  key={language.key}
                  selected={this.props.userLanguage === language.key}
                  onClick={() => this.changeLanguage(language.key)}
                >
                  <Trans i18nKey={language.text} />
                </MenuItem>
              ))}
            </Menu>
            <IconButton
              color="inherit"
              className={classes.messagesButton}
              onClick={this.openMessages}
              ref={messageRef}
              id="open-notifications"
              aria-label="Open notifications"
            >
              <Badge badgeContent={this.props.userUnreadMessages} color="secondary">
                <>
                  {this.props.userUnreadMessages > 0 ? (
                    <NotificationsIcon />
                  ) : (
                    <NotificationsNoneIcon />
                  )}
                </>
              </Badge>
            </IconButton>
            <Tooltip
              title={
                <Typography>
                  Say "Knowledge search" followed by your search text.
                </Typography>
              }
            >
              <IconButton
                color="inherit"
                onClick={() => {
                  this.setState({ micOn: !this.state.micOn });
                }}
              >
                <Badge color="secondary">
                  <>{this.state.micOn ? <MicIcon /> : <MicOffIcon />}</>
                </Badge>
              </IconButton>
            </Tooltip>
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                {/* {Object.keys(this.props.filters).length > 0 && (
                  <Badge color="secondary" variant="dot">
                    <FilterListIcon />
                  </Badge>
                )} */}
                <SearchIcon />
              </div>
              <InputBase
                aria-label={t("search_text_input")}
                inputRef={this.handleInputRef}
                placeholder={t("global_search") + "..."}
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                onClick={this.openSearchFilter}
                value={this.state.searchString}
                onChange={(s) =>
                  this.setState({ searchString: s.target.value })
                }
                onKeyDown={this.searchKeypress}
                id="search-box"
              />
            </div>
          </Toolbar>
          <div className={classes.tabsContainer}>
            {this.state.main && (
              <>
                <IconButton
                  aria-label={
                    this.state.userTabs
                      ? "Switch to team layouts"
                      : "Switch to user layouts"
                  }
                  className={classes.layoutButton}
                  color="inherit"
                  onClick={this.toggleTeamLayouts}
                  disabled={this.props.currentUser.userType === "limited"}
                >
                  {this.state.userTabs ? <PersonIcon /> : <PeopleIcon />}
                </IconButton>
                {!this.state.userTabs &&
                  this.state.main && (
                    <FormControl className={classes.select}>
                      <Select
                        className={classes.teamSelect}
                        inputProps={{
                          classes: {
                            root: classes.icon,
                            icon: classes.icon,
                            id: "demo-simple-select-label",
                          },
                        }}
                        defaultValue={this.state.selectedTeam}
                        onChange={this.teamChange}
                      >
                        {this.state.userTeams.map((team) => (
                          <MenuItem value={team.teamId}>
                            <Table className={classes.menuTable}>
                              <TableRow>
                                <TableCell
                                  align="left"
                                  className={classes.menuCellLeft}
                                >
                                  {team.teamName}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  className={classes.menuCellRight}
                                >
                                  {/* <Badge badgeContent={team.numberOfSharedLayouts} color="primary">
                                    <></>
                                  </Badge> */}
                                  {team.numberOfSharedLayouts}
                                </TableCell>
                              </TableRow>
                            </Table>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                <PortalTabs
                  userTabs={this.state.userTabs}
                  onRemoveTab={this.removeTab}
                />
              </>
            )}
            {/* {!this.state.userTabs &&
              this.state.main && (
                <>
                  <div style={{ flex: 1, display: "flex" }} />
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    defaultValue={1}
                    onChange={this.teamChange}
                  >
                    {this.state.userTeams.map((team) => (
                      <MenuItem value={team.id}>{team.name}</MenuItem>
                    ))}
                  </Select>
                </>
              )}
            {this.props.history.location.pathname.includes("search") && (  */}
            {this.props.history.location.pathname.includes("topic") && this.state.topicId !== -1 && (
              <>
                <DisplayLocation
                  type="TOPIC"
                  itemId={this.state.topicId}
                  topicId={this.state.topicId}
                  title={this.state.topicName}
                  onClick={() => {this.setState({showTopicDialog: true})}}
                  isTitle
                  textQualifier={this.state.topicName && this.state.topicName !== "" ? " home page" : ""}
                />
              </>
            )}
            {this.state.routeSearchString &&
              this.props.history.location.pathname.includes("search") && (
                <div style={{ display: "flex", width: "100%" }}>
                  <Media query="(min-width: 800px)">
                    <div
                      style={{ display: "flex", marginRight: "auto", flex: 1 }}
                    >
                      <Typography
                        variant="subtitle1"
                        component="h2"
                        className={classes.searchStringText}
                      >
                        {this.state.routeSearchString.trim().length > 0 ? (
                          <>
                            <Trans i18nKey="search_page_showing_results_for" />
                            &nbsp;{this.state.routeSearchString}{" "}
                            {this.state.numSearchResults > 0 &&
                              this.state.searchTime > 0 &&
                              this.props.t("search_found_in_time", {
                                numResults: this.state.numSearchResults,
                                time: this.state.searchTime,
                              })}
                          </>
                        ) : (
                          <>
                            {this.props.t("search_found_in_time", {
                              numResults: this.state.numSearchResults,
                              time: this.state.searchTime,
                            })}
                          </>
                        )}
                      </Typography>
                    </div>
                  </Media>
                  <>
                    <Popper
                      open={this.state.whyPopperOpen}
                      anchorEl={this.state.whyPopperAnchorEl}
                      className={classes.popper}
                      placement="bottom"
                      modifiers={{
                        flip: {
                          enabled: false,
                        },
                        preventOverflow: {
                          enabled: true,
                          boundariesElement: "scrollParent",
                        },
                      }}
                    >
                      <Paper className={classes.paper} elevation={10}>
                        <DialogTitle>
                          {t("why_link_documents_to_a_search")}
                          <IconButton
                            aria-label={"Close"}
                            className={classes.closeButton}
                            onClick={this.closePopper}
                          >
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>
                        <DialogContent>
                          <Typography style={{ lineHeight: 2 }}>
                            {t("link_document_to_search_explanation")}
                          </Typography>
                          <br />
                          <Typography style={{ lineHeight: 2 }}>
                            {t("link_document_use_link_icon")} <LinkIcon />{" "}
                            {t("change_to_show_linked_document")}{" "}
                            <CheckCircleIcon className={classes.green} />{" "}
                            {t("to_unlink_document")} <LinkOffIcon />{" "}
                            {t("menu_bar_linked_documents")}
                          </Typography>
                          <br />
                          <Typography style={{ lineHeight: 2 }}>
                            {t("search_string_showing_this_icon")}{" "}
                            <svg
                              style={{ width: 24, height: 24 }}
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill={theme.palette.secondary.main}
                                d={mdiLightbulbOnOutline}
                              />
                            </svg>{" "}
                            {t("has_been_linked_to_previous_search")}
                          </Typography>
                        </DialogContent>
                      </Paper>
                    </Popper>
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <div>
                        <IconButton
                          onClick={this.showWhyLinkPopper}
                          aria-label="Information about linking documents to a search"
                        >
                          <InfoIcon className={classes.infoButton} />
                        </IconButton>
                      </div>
                      <div>
                        <Typography
                          variant="subtitle1"
                          component="h2"
                          className={classes.searchStringText}
                        >
                          {this.state.resolutions.length}{" "}
                          {t("documents_are_linked_to_this_search")}
                        </Typography>
                      </div>
                      <div>
                        {this.state.resolutions.length > 0 && (
                          <Tooltip
                            title={
                              <Typography>
                                {t("clear_documents_linked_to_search")}
                              </Typography>
                            }
                            enterDelay={300}
                          >
                            <IconButton
                              id="clear-documents-linked-to-search"
                              onClick={this.clearResolutions}
                              aria-label="Clear documents linked to this search"
                              color="inherit"
                            >
                              <LinkOffIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>
                    </div>
                  </>
                  <div style={{ flex: 1, display: "flex" }}>
                    <IconButton
                      id="search-settings-button"
                      color="inherit"
                      style={{ marginLeft: "auto" }}
                      aria-label={"Search settings"}
                      onClick={(e) => {
                        this.setState({ settingsAnchorEl: e.currentTarget });
                      }}
                    >
                      <Tooltip
                        title={
                          <Typography>{t("search_settings_header")}</Typography>
                        }
                      >
                        <SettingsIcon />
                      </Tooltip>
                    </IconButton>
                    <Popover
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      open={Boolean(this.state.settingsAnchorEl)}
                      anchorEl={this.state.settingsAnchorEl}
                      onClose={() => this.setState({ settingsAnchorEl: null })}
                    >
                      <Paper style={{ padding: 20 }}>
                        <Typography gutterBottom variant="h6">
                          {t("search_settings_header")}
                        </Typography>
                        <SearchSecondaryInfo
                          secondaryInfo={this.state.secondaryInfo}
                          onChange={(secondaryInfo) =>
                            this.setState({ secondaryInfo })
                          }
                        />
                      </Paper>
                    </Popover>
                  </div>
                </div>
              )}
          </div>
          {/* </> */}
        </AppBar>
        <Switch location={this.props.location} style={{ height: "100%" }}>
          <Route path="/" exact component={this.RouterUserLayouts} />
          <Route
            path="/full/document/:id"
            render={(props) =>
              this.getFullscreenDialog(
                props,
                this.documentViewerTitleGetter,
                this.documentViewerContentGetter
              )
            }
          />
          <Route
            path="/full/globalcustomfields"
            component={this.RouterGlobalCustomFields}
          />
          <Route
            path={["/topic/:topic","/topic"]}
            component={this.RouterTopicPage}
          />
          <Route
            path={[
              "/search/:str/document/:docid",
              "/search/:str",
              "/search/",
              "/advancedsearch/",
            ]}
            component={this.RouterSearchPage}
          />
          {/* <Route
            path={["/search/:str", "/advancedsearch/"]}
            component={this.RouterSearchPage}
          /> */}
          <Route path="/fullscreen" component={this.RouterElementWrapper} />
          <Route path="/profile" component={this.RouterProfilePage} />
          {/* <Route path="/layout/:id" component={this.RouterUserLayouts} /> */}
          <Route
            path="/full/discussion/:id"
            render={(props) =>
              this.getFullscreenDialog(
                props,
                this.discussionViewerTitleGetter,
                this.discussionViewerContentGetter
              )
            }
          />
          <Route
            path={[
              "/search/:str/document/:docid",
              "/search/:str",
              "/search/",
              "/advancedsearch/",
            ]}
            component={this.RouterSearchPage}
          />
          <Route
            path="/full/knowledgeitem/:id"
            render={(props) =>
              currentUserHasRole(Role.BE_EXPERT) ||
              currentUserHasRole(Role.SYSTEM_MANAGER) ? (
                this.getFullscreenDialog(
                  props,
                  this.knowledgeItemTitleGetter,
                  this.knowledgeItemContentGetter,
                  props.match.url
                )
              ) : (
                <Redirect to="/" />
              )
            }
          />
          {!this.props.isMobile && (
            <>
              <Route
                path="/full/managetemplates/"
                render={(props) =>
                  this.getFullscreenDialog(
                    props,
                    this.manageTemplatesTitleGetter,
                    this.manageTemplatesContentGetter
                  )
                }
              />
              <Route
                path="/full/translations"
                render={(props) =>
                  currentUserHasRole(Role.SYSTEM_MANAGER) ? (
                    this.getFullscreenDialog(
                      props,
                      this.translationsTitleGetter,
                      this.translationsContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/reusablesections"
                render={(props) =>
                  currentUserHasRole(Role.CONTENT_ADMIN) ? (
                    this.getFullscreenDialog(
                      props,
                      this.reusableSectionsTitleGetter,
                      this.reusableSectionsContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/useradmin"
                render={(props) =>
                  currentUserHasRole(Role.ADMINISTRATOR) ? (
                    this.getFullscreenDialog(
                      props,
                      this.userAdminTitleGetter,
                      this.userAdminContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              {this.props.applicationProperties[
                PropertyNames.DISCUSSIONS_ENABLED
              ] === "true" && (
                <Route
                  path="/full/taxonomydiscussions"
                  render={(props) =>
                    this.getFullscreenDialog(
                      props,
                      this.taxonomyDiscussionsTitleGetter,
                      this.taxonomyDiscussionsContentGetter
                    )
                  }
                />
              )}
              <Route
                path="/full/manageattachments"
                render={(props) =>
                  currentUserHasRole(Role.SYSTEM_MANAGER) ? (
                    this.getFullscreenDialog(
                      props,
                      this.manageAttachmentsTitleGetter,
                      this.manageAttachmentsContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/createexpertquestion"
                render={(props) =>
                  currentUserHasRole(Role.ASK_EXPERT) ? (
                    this.getFullscreenDialog(
                      props,
                      this.createExpertQuestionTitleGetter,
                      this.createExpertQuestionContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/createexpertquestiontemplate"
                render={(props) =>
                  currentUserHasRole(Role.BE_EXPERT) ||
                  currentUserHasRole(Role.SYSTEM_MANAGER) ? (
                    this.getFullscreenDialog(
                      props,
                      this.createExpertQuestionTemplateTitleGetter,
                      this.createExpertQuestionTemplateContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/managerr"
                render={(props) =>
                  currentUserHasRole(Role.REQUIRED_READING) ? (
                    this.getFullscreenDialog(
                      props,
                      this.manageRRTitleGetter,
                      this.manageRRContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/knowledgesource"
                render={(props) =>
                  currentUserHasRole(Role.MODERATOR) ? (
                    this.getFullscreenDialog(
                      props,
                      this.addKnowledgeSourceTitleGetter,
                      this.addKnowledgeSourceContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/manageks"
                render={(props) =>
                  currentUserHasRole(Role.MODERATOR) ? (
                    this.getFullscreenDialog(
                      props,
                      this.manageKnowledgeSourceTitleGetter,
                      this.manageKnowledgeSourceContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/managebatchreindex"
                render={(props) =>
                  currentUserHasRole(Role.MODERATOR) ? (
                    this.getFullscreenDialog(
                      props,
                      this.manageBatchReindexingTitleGetter,
                      this.manageBatchReindexingContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/managejobs"
                render={(props) =>
                  currentUserHasRole(Role.SYSTEM_MANAGER) ? (
                    this.getFullscreenDialog(
                      props,
                      this.jobManagerTitleGetter,
                      this.jobManagerContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/system-configuration"
                render={(props) =>
                  currentUserHasRole(Role.SYSTEM_MANAGER) ? (
                    this.getFullscreenDialog(
                      props,
                      this.systemConfigurationTitleGetter,
                      this.systemConfigurationContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/taxonomymaintenance"
                render={(props) =>
                  currentUserHasRole(Role.SYSTEM_MANAGER) ? (
                    this.getFullscreenDialog(
                      props,
                      this.taxonomyMaintenanceTitleGetter,
                      this.taxonomyMaintenanceContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/documentmanager"
                render={(props) =>
                  currentUserHasRole(Role.MODERATOR) ? (
                    this.getFullscreenDialog(
                      props,
                      this.documentManagerTitleGetter,
                      this.documentManagerContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/full/createcontent"
                render={(props) =>
                  currentUserHasRole(Role.BE_EXPERT) ||
                  currentUserHasRole(Role.SYSTEM_MANAGER) ? (
                    this.getFullscreenDialog(
                      props,
                      this.createContentTitleGetter,
                      this.createContentContentGetter
                    )
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
            </>
          )}
        </Switch>

        {/* {(this.state.searchOpened && !this.props.history.location.pathname.includes("search")) && ( */}
        {/* {this.state.searchOpened && (
          <SearchBar
            asPopper
            anchorEl={this.state.searchAnchorEl}
            open={this.state.searchOpened}
            onClickAway={this.handleClickAway}
            onClose={this.closeSearchBar}
            searchString={this.state.searchString}
            activateSearch={this.activateSearch}
            searchInProgress={
              this.props.location.pathname.indexOf("search") > 0
            }
          />
        )} */}

        {this.state.messageOpened && (
          <NotificationDialog
            anchorEl={this.state.messageAnchorEl}
            open={this.state.messageOpened}
            onClickAway={this.handleMessageClickAway}
            onClose={this.closeMessageBar}
            userTotalMessages={this.props.userTotalMessages}
            userUnreadMessages={this.props.userUnreadMessages}
            updateNotifications={this.props.updateNotifications}
            //data={this.props.messages}
          />
        )}
      </div>
    );
  }
  handleFullscreenDialogClosed = () => {
    this.setState({ fullscreenDialogOpen: false });
    if (
      this.props.lastLocation &&
      !this.props.lastLocation.pathname.includes("/full/knowledgeitem/") &&
      !this.props.lastLocation.pathname.includes("/full/taxonomydiscussions/")
    ) {
      this.props.history.goBack();
    } else {
      this.props.history.push("/");
    }
  };

  documentManagerTitleGetter = (props) => {
    return this.props.t("admin_document_manager");
  };

  documentManagerContentGetter = (props) => {
    return <DocumentManager {...props} />;
  };

  createContentTitleGetter = (props) => {
    return this.props.t("create_content");
  };

  createContentContentGetter = (props) => {
    return <CreateContentFlow {...props} />;
  };

  systemConfigurationTitleGetter = (props) => {
    return this.props.t("admin_system_configuration");
  };

  systemConfigurationContentGetter = (props) => {
    const { classes } = this.props;
    return <SystemConfiguration />;
  };

  jobManagerTitleGetter = (props) => {
    return this.props.t("job_manager");
  };

  jobManagerContentGetter = (props) => {
    const { classes } = this.props;
    return <JobManager />;
  };

  manageKnowledgeSourceTitleGetter = (props) => {
    return this.props.t("drawer_manage_knowledge_sources");
  };

  manageKnowledgeSourceContentGetter = (props) => {
    const { classes } = this.props;
    return <ManageKnowledgeSources />;
  };

  manageBatchReindexingTitleGetter = (props) => {
    return this.props.t("manage_batch_reindexing");
  };

  manageBatchReindexingContentGetter = (props) => {
    const { classes } = this.props;
    return <ManageBatchReindexing />;
  };

  addKnowledgeSourceTitleGetter = (props) => {
    if (props.location.state && props.location.state.edit) {
      return this.props.t("edit_knowledge_source");
    }
    return this.props.t("drawer_create_knowledge_source");
  };

  addKnowledgeSourceContentGetter = (props) => {
    const { classes } = this.props;
    return <CreateKnowledgeSource />;
  };

  manageRRTitleGetter = (props) => {
    return this.props.t("manage_required_reading");
  };

  manageRRContentGetter = (props) => {
    const { classes } = this.props;
    return <ManageRequiredReading />;
  };

  manageAttachmentsTitleGetter = (props) => {
    return this.props.t("admin_manage_attachments");
  };

  manageAttachmentsContentGetter = (props) => {
    const { classes } = this.props;
    return <ManageAttachments />;
  };

  documentViewerTitleGetter = (props) => {
    return `${this.props.t("viewing_document")} ${props.match.params.id}`;
  };

  documentViewerContentGetter = (props) => {
    const { classes } = this.props;
    let location = props.location;
    return (
      <DocumentViewer
        discussionId={this.getDiscussionId()}
        documentId={parseInt(props.match.params.id)}
        className={classes.docViewer}
        key={props.match.params.id}
        bookmark={location.hash}
        initialSearch={this.state.initialSearch}
      />
    );
  };
  manageTemplatesTitleGetter = (props) => {
    return this.props.t("manage_templates");
  };

  manageTemplatesContentGetter = (props) => {
    return (
      <TemplatePicker
        noFromFile
        hideNext
        noNext
        hideTitle
        props={{ ...props }}
        // noFromFile={props.noFromFile}
        // noElevation={props.noElevation}
        isStart
        show={true}
        // style={{ display:  "block" : "none" }}
        onTemplateSelected={(template) => {}}
        // nextFileUpload={nextFileUpload}
        // nextText={
        //   <Trans i18nKey="create_content_use_template_button">
        //     create_content_use_template_button
        //   </Trans>
        // }
        // next={next}
      />
    );
  };

  discussionViewerTitleGetter = (props) => {
    return `${this.props.t("viewing_discussion")} ${props.match.params.id}`;
  };

  discussionViewerContentGetter = (props) => {
    const { classes } = this.props;
    return <FullscreenDiscussion discussionId={props.match.params.id} />;
  };
  taxonomyDiscussionsTitleGetter = (props) => {
    return this.props.t("taxonomy_discussions");
  };

  taxonomyDiscussionsContentGetter = (props) => {
    const { classes } = this.props;
    return <TaxonomyDiscussions props={{ ...props }} />;
  };
  knowledgeItemTitleGetter = (props) => {
    let title =
      this.props.t("global_viewing") +
      " " +
      this.props.t("global_knowledge_item");
    if (props.location.pathname.indexOf("/document/") > -1) {
      title =
        this.props.t("viewing_document_for") +
        " " +
        this.props.t("global_knowledge_item");
    } else if (props.location.pathname.indexOf("/revision/") > -1) {
      title =
        this.props.t("viewing_revision") +
        " " +
        props.location.pathname.substring(
          props.location.pathname.indexOf("/revision/") + 10
        );
    } else if (props.location.pathname.indexOf("/newrevision") > -1) {
      title =
        this.props.t("creating_new_revision_for") +
        " " +
        this.props.t("global_knowledge_item");
    }
    return title;
  };

  knowledgeItemContentGetter = (props) => {
    const { classes } = this.props;
    return <KnowledgeItemView kiId={props.match.params.id} />;
  };

  taxonomyMaintenanceTitleGetter = (props) => {
    return this.props.t("global_taxonomy_maintenance");
  };

  taxonomyMaintenanceContentGetter = (props) => {
    const { classes } = this.props;
    return <TaxonomyMaintenance />;
  };
  getDiscussionId = (props) => {
    let discussionID = null;
    if (this.props.location.state != null) {
      discussionID = this.props.location.state.discussionId;
    } else {
      return null;
    }
    if (discussionID != null) {
      return discussionID;
    } else {
      return null;
    }
  };

  translationsTitleGetter = (props) => {
    return this.props.t("drawer_translation_editor");
  };

  translationsContentGetter = (props) => {
    return <TranslationEditor />;
  };

  reusableSectionsTitleGetter = (props) => {
    return this.props.t("reusable_section_manager");
  };

  reusableSectionsContentGetter = (props) => {
    return <ReusableSections />;
  };

  userAdminTitleGetter = (props) => {
    return this.props.t("drawer_user_administration");
  };

  userAdminContentGetter = (props) => {
    return <UserAdministration />;
  };

  createExpertQuestionTemplateTitleGetter = (props) => {
    return this.props.t("create_expert_question_template");
  };

  createExpertQuestionTemplateContentGetter = (props) => {
    // return <CreateExpertQuestionTemplate />;
    return <ExpertQuestionMaintenance expert />;
  };

  createExpertQuestionTitleGetter = (props) => {
    return this.props.t("create_expert_question");
  };

  createExpertQuestionContentGetter = (props) => {
    return <ExpertQuestionMaintenance />;
  };

  getFullscreenDialog = (props, titleGetter, contentGetter) => {
    const { classes, t } = this.props;
    if (!this.state.fullscreenDialogOpen) {
      this.setState({ fullscreenDialogOpen: true });
    }
    return (
      <Dialog
        disableEnforceFocus
        fullScreen
        open={this.state.fullscreenDialogOpen}
        onClose={this.handleFullscreenDialogClosed}
        classes={{ paper: classes.dialogContainer }}
      >
        <AppBar
          className={classNames("pdf-hide", classes.modalAppBar)}
          // style={{ position: "fixed" }}
        >
          <Toolbar className={classes.modalToolbar}>
            {this.props.lastLocation ? (
              <IconButton
                color="inherit"
                onClick={() => this.props.history.goBack()}
                aria-label={t("go_back")}
                autoFocus
              >
                <ArrowBackIcon />
              </IconButton>
            ) : (
              <div style={{ width: 80 }} />
            )}
            <Typography
              variant="h6"
              component="h1"
              color="inherit"
              className={classes.flex}
            >
              {titleGetter(props)}
            </Typography>
            <IconButton
              color="inherit"
              className={classes.exitButton}
              aria-label={t("report_breadcrumb_home")}
              onClick={() => this.props.history.push("/")}
              id="go-home"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        {contentGetter(props)}
      </Dialog>
    );
  };
  changeLanguage = (language) => {
    this.props.changeLanguage(language);
    this.handleLanguageMenuClose();
  };

  handleLanguageIconClick = (e) => {
    this.setState({ languageMenu: e.currentTarget });
  };

  handleLanguageMenuClose = (e) => {
    this.setState({ languageMenu: null });
  };

  closeSearchBar = () => {
    this.setState({ searchString: "", searchOpened: false });
  };

  closeMessageBar = () => {
    this.setState({ messageOpened: false });
  };

  openMessages = () => {
    this.setState({ messageOpened: true });
  };

  searchKeypress = (e) => {
    if (e.keyCode === 13) {
      this.closeSearchBar();
      this.props.history.push(`/search/${this.state.searchString}`);
    }
  };

  goHome = () => {
    this.props.history.push("/");
  };

  RouterUserLayouts = (props) => {
    // this.props.changeSelected(0);
    
    if (this.props.match.params.id) {
      return (<></>)
    } else {
      return (
        <UserLayouts
          userLayout={this.state.userTabs}
          selectedTeam={this.state.selectedTeam}
          setSelectedTeam={(team) => {
            this.setState({selectedTeam: team})
          }}
          {...props}
        />
      )
    }

  };
  RouterProfilePage = (props) => {
    return <UserSettings {...props} />;
  };

  RouterElementWrapper = (props) => {
    return (
      <ElementWrapper
        fullscreen
        portlet={this.state.fullScreenPortlet}
        {...props}
      />
    );
  };
  RouterGlobalCustomFields = (props) => {
    if (!currentUserHasRole(Role.BE_EXPERT)) return <Redirect to="/" />;
    return <CustomFields global {...props} />;
  };
  updateTopic = (newTopic) => {
    this.setState({topicId: newTopic.id, topicName: newTopic.name})
    this.props.history.replace(`/topic/${newTopic.id}`)
  }
  closeTopicDialog = () => {
    this.setState({showTopicDialog: false})
  }
  RouterTopicPage = (props) => {
    return(
      <TopicHomePage 
        topicId={props.match.params.topic}
        isMobile={this.props.isMobile}
        updateTopic={this.updateTopic}
        showTopicDialog={this.state.showTopicDialog}
        closeTopicDialog={this.closeTopicDialog}
      />
    )
  }
  RouterSearchPage = (props) => {
    return (
      <SearchPage
        searchString={this.state.searchString}
        onResolution={this.onResolution}
        onUnResolved={this.onUnResolved}
        setPreviousResolutions={this.setPreviousResolutions}
        setSearchStats={this.setSearchStats}
        setSearchId={this.setSearchId}
        resolutions={this.state.resolutions}
        secondaryInfo={this.state.secondaryInfo}
        {...props}
      />
    );
  };
  setPreviousResolutions = (prevResolutions) => {
    this.setState({
      resolutions: [...prevResolutions],
    });
  };
  setSearchStats = (results, time) => {
    this.setState({ numSearchResults: results, searchTime: time });
  };
  setSearchId = (searchId) => {
    this.setState({ searchId: searchId });
  };
  clearResolutions = () => {
    axios.delete(`/search/${this.state.searchId}/resolutions/`).then((res) => {
      this.setState({
        resolutions: this.state.resolutions.filter(
          (r) => typeof r === "object"
        ),
      });
    });
  };
  onResolution = (res) => {
    this.state.resolutions.indexOf(res) < 0 &&
      this.setState((prevState) => ({
        resolutions: Array.prototype.concat(prevState.resolutions, [res]),
      }));
  };

  onUnResolved = (res) => {
    this.setState((prevState) => ({
      resolutions: prevState.resolutions.filter((item) => item !== res),
    }));
  };
  toggleTeamLayouts = () => {
    this.props.changeSelected(0);
    {
      this.state.userTabs && this.getUserTeams();
    }
    this.setState(
      (prev) => ({ userTabs: !prev.userTabs }),
      () => {
        this.props.setLayoutType(this.state.userTabs ? "user" : "team");
      }
    );
  };

  removeTab = () => {};

  toggleDrawer = () => {
    this.setState((prev) => ({ drawerOpen: !prev.drawerOpen }));
  };
  openProfilePage = () => {
    this.setState({ drawerOpen: false });
    this.props.history.push("/profile");
  };
  _openElementWrapper = (e) => {
    var portlet = e.detail.portlet;
    portlet.instance = null;
    portlet.cansort = false;
    this.setState({ fullScreenPortlet: portlet });
    this.setState({ drawerOpen: false });
    this.props.history.push("/fullscreen");
  };
}

const mapStateToProps = (state) => ({
  edit: state.layout.edit,
  searchOpened: state.search.open,
  userLanguage: state.user.language,
  currentUser: state.user.currentUser,
  filters: state.search.filters,
  applicationProperties: state.setting.applicationProperties,
  isMobile: state.screen.isMobile,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
});

const mapDispatchToProps = {
  setLayoutType,
  changeLanguage,
  changeSelected,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    withTheme(
      withStyles(styles)(withLastLocation(withTranslation()(KpsLayout)))
    )
  )
);
